import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SpinnerData } from '../../applicant.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApplicantService } from '../../applicant.service';
import { environment as ENV } from '../../../environments/environment';
import { AddCustomerService } from '../add-customer-new/add-customer.service';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  providers: [AddCustomerService]
})
export class LoadingComponent implements OnInit {

  loading: any;
  showSpinner: boolean;
  showSpinnerWithMessage: boolean;
  subText: any;
  payment: boolean;
  totalCount: number;
  isDataPending: boolean;
  users: any[];
  seg: any;
  allUsers: any[];
  totalPage: number;
  iscustomerSegment: string;
  roleId: string;
  viewprojectname: string;

  constructor(private applicant: ApplicantService, private cust: AddCustomerService, private snackbar: MatSnackBar, private router: Router) {
  }

  ngOnInit() {
    this.applicant.stringSubject.subscribe((spinnerData: SpinnerData) => {
      console.log(spinnerData)
      this.showSpinner = (spinnerData['showSpinner']);
      this.showSpinnerWithMessage = spinnerData['spinnerWithMessage'];
      this.subText = spinnerData['subText'];

    })

    this.showSpinner = true;

    this.viewprojectname = ENV.viewCustomerProjectName;

    if (sessionStorage.getItem('custselfjourney') == 'custselfjourney') {
      // this.selfJourney = true;
      this.verifyPayment();

    } else if (sessionStorage.getItem('custselfjourney') == 'assistedjourney') {
      // this.selfJourney = false;
      // this.verifyPayment();
       this.verifyPaymentStatus();
    }

   
  }


  verifyPayment() {

    let userId;
     this.viewprojectname == "dfid" ?   userId =  sessionStorage.getItem('appId') : userId =  localStorage.getItem("wl-applicant-id");

    const data = {

      "project": ENV.viewCustomerProjectName,
      "userId": userId ,
      // "basePath": "payment",
      // "containerName": "verifypayment",
      "order_id": sessionStorage.getItem('orderId')

    }
    console.log("Data", data);                
    this.showSpinner = true;
    this.cust.verifyPayment(data).subscribe(resp => {
      this.showSpinner = false;
      if (resp && resp.paymentStatus) {

        console.log(resp)
        if (resp.paymentStatus?.payment_status == 'success') {
          this.snackbar.open("Payment is successful", "OK", { duration: 3000 })
          this.payment = true;

        } else if (resp.paymentStatus?.payment_status == 'created') {
          this.snackbar.open("Order has been created successful", "OK", { duration: 3000 })
          // window.open(ENV.frontendUrl + '/dashboard/wallet');
          this.payment = false;
          // localStorage.removeItem("wl-applicant-id")
        } else {
          this.snackbar.open("Payment failed, please try again", "OK", { duration: 3000 })
          this.payment = false;

        }


      } else {
           this.snackbar.open("Payment is not  successful, please try again", "OK", { duration: 3000 })
        this.payment = false;
      }

    }, err=> {
      this.showSpinner = false;     
      this.snackbar.open("Payment is not  successful, please try again", "OK", { duration: 3000 })
    })

    if(this.viewprojectname == "dfid"){
  this.router.navigate(['/dashboard/view-customer']);
    } else {
  this.router.navigate(['/dashboard/wallet']);
  }
    }
  


  verifyPaymentStatus() {

    let userId;
    this.viewprojectname == "dfid" ?   userId =  sessionStorage.getItem('appId') : userId =  sessionStorage.getItem('adminId');

    let data = {
      project : ENV.viewCustomerProjectName,
      userId: userId,
      order_id : sessionStorage.getItem('orderId')
    }
    this.applicant.verifyPaymentStatus(data).subscribe((resp) => {
      debugger
      console.log(resp);

      if(this.viewprojectname == "dfid"){
         this.router.navigate(['/dashboard/view-customer'], { state: { paymentStatus: resp.message} });
    } else {
        this.router.navigate(['/dashboard/wallet'], { state: { paymentStatus: resp.message} });
  }
      
    }, err => {
      this.snackbar.open("Failed to check the payment status, please try later", "OK", { duration: 3000 });
    });
  }

// const paymentStatus = this.router.getCurrentNavigation()?.extras.state?.paymentStatus;
}
